import './bugsnag';
import React from 'react';
import ReactDOM from 'react-dom';
import 'babel-polyfill';

import './shared/algolia-theme.css';
import './shared/styles';

import Root from './containers/Root/Root';
import Maintenance from './components/Maintenance/Maintenance';
import { isMaintenanceMode } from './shared/maintenance';
import registerServiceWorker from './registerServiceWorker';

if (isMaintenanceMode()) {
    // Render the standalone maintenance screen and skip the service worker so a
    // previously-cached app shell can't fight the maintenance deploy.
    ReactDOM.render(<Maintenance />, document.getElementById('root'));
} else {
    ReactDOM.render(<Root />, document.getElementById('root'));
    registerServiceWorker();
}



// WEBPACK FOOTER //
// ./src/index.js